// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1zDhH","content-wrapper":"_3uovH"};